<template>
  <div class="container-fluid my-3 room" style="min-height:50vh">
    <div class="row">
      <div class="col-12" v-if="step===0">
        <h3>編輯考場</h3>
        <div class="d-flex align-items-center">
          <label class="m-0 mr-2">考場名稱:</label>
          <input type="text" v-model="roomData.name">
        </div>
        <div class="my-2">
          <div class="d-flex align-items-center">
            <label class="m-0 mr-2">日期區間:</label>
            <date-picker valueType="format" v-model="range" :format="'YYYY-MM-DD HH:mm'" :showTimeHeader="true" type="datetime" :showSecond="false" range placeholder="請選擇日期區間"></date-picker>
          </div>
        </div>
        <div class="my-2" style="text-align: left;">
          <label>備註:</label>
          <div class="d-flex align-items-center">
            <textarea v-model="roomData.note" placeholder="新增備註" style="resize:none;width:600px;height:200px;"></textarea>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <input type="checkbox" id="playableCheckbox" v-model="roomData.sound_playable">
          <span class="ml-2" for="checkbox">學生考試時，可播放範例音檔</span>
        </div>
        <div class="d-flex align-items-center">
          <input type="checkbox" id="checkbox" v-model="roomData.is_repeatable">
          <span class="ml-2" for="checkbox">開放學生作答時重複錄音,作答以最後一次錄音為準</span>
        </div>
        <div class="d-flex align-items-center">
          <input type="checkbox" id="showScoreCheckbox" v-model="roomData.is_show_score">
          <span class="ml-2" for="checkbox">立即顯示測驗分數</span>
        </div>
      </div>
      <div class="row col-12 my-2">
        <div class="col-12 my-5" v-if="step===1">
          <h3>選擇應試班級</h3>
          <div class="list-group" v-for="(item, index) in inputGroup" :key="index">
            <div v-if="!isSelectedGroup(item.id)" @click="addGroup(item.id)" class="list-group-item list-group-item-action pointer mb-1">{{ item.name }}</div>
            <div v-else @click="deleteGroup(item.id)" class="list-group-item list-group-item-action pointer mb-1 active">{{ item.name }}</div>
          </div>
        </div>
        <div class="col-12 row" v-if="step===2">
          <div class="col-12">
            <div style="float: right;" class="d-flex align-items-center my-3">
              <input type="text" v-model="search">
              <button @click="getOralList" type="button" class="btn btn-danger ml-2">搜尋</button>
            </div>
          </div>
          <div class="col-6 oralList">
            <h3>課程清單</h3>
            <div class="list-group" v-for="(option, index) in oralList" :key="index">
              <div v-if="!isSelected(option.id)" class="list-group-item list-group-item-action pointer mb-1" @click="addOral(option.id)">{{ option.name }}</div>
              <div v-else class="list-group-item list-group-item-action pointer mb-1 active" @click="deleteOral(option.id)">{{ option.name }}</div>
            </div>
          </div>
          <div class="col-6 oralList">
            <h3>已選課程</h3>
            <div class="list-group" v-for="(option, index) in selectedOralList" :key="index">
              <div class="list-group-item list-group-item-action pointer mb-1 active" @click="deleteOral(option.id)">{{ option.name }}</div>
            </div>
          </div>
          <pagination v-if="step===2" class="m-auto col-12 pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
        </div>
        <div class="col-12 row" v-if="step===3">
          <div class="col-6 oralList">
            <h3>已選課程</h3>
            <div class="list-group" v-for="(option, index) in selectedOralList" :key="index">
              <div class="list-group-item list-group-item-action pointer mb-1" @click="getExam(index)" :class="{'active': examIndex === index}">{{ option.name }}</div>
            </div>
          </div>
          <div class="col-6 oralList">
            <h3>考題清單</h3>
            <div v-if="examData" class="list-group" v-for="(item, index) in examData[examIndex].sentences" :key="index">
              <div class="list-group-item list-group-item-action pointer mb-1" @click="sentencesToggle(item)" :class="{'active': item.is_selected}" >{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div style="float:right">
          <button v-if="step>0"  @click="step--" type="button" class="btn btn-danger">上一步</button>
          <button v-if="step===3"  @click="editRoomData" type="button" class="btn btn-danger mx-2">完成</button>
          <button v-else @click="step++" :disabled="step===2 && selectedOralList.length===0" type="button" class="btn btn-danger mx-2">下一步</button>
        </div>
      </div>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination.vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import api from '../../../store/api'
export default {
  name: 'ModifyRoom',
  data () {
    return {
      step: 0,
      selectedGroupList: [],
      roomData: [],
      selectedPage: false,
      oralList: [],
      selectedOralList: [],
      range: [],
      search: '',
      examIndex: 0,
      examData: [],
      coursesId: 0,
      pageIndex: 1,
      pageCount: 0
    }
  },
  props: {
    inputGroup: {
      required: true
    }
  },
  computed: {
    groupId () {
      return this.$route.params.groupId
    },
    roomId () {
      return this.$route.params.roomId
    },
    isSelected() {
      return (optionId) => {
        return this.selectedOralList.some(el => el.id === optionId);
      }
    },
    isSelectedGroup() {
      return (optionId) => {
        return this.selectedGroupList.some(el => el.id === optionId);
      }
    },
  },
  components: {
    DatePicker,
    Pagination
  },
  watch: {
    step (val) {
      if (val === 3) {
        this.examPreview()
      }
    },
    examIndex (val) {
      this.coursesId = this.examData[val].friendly_id
    }
  },
  async mounted () {
    await this.getRoomData()
    await this.getOralList()
    await this.getSelectedOralList()
    await this.getSelectedGroupList()
  },
  methods: {
    async getRoomData () {
      const { data } = await api.get(`liveabc/rooms/${this.roomId}`)
      this.roomData = data.data.room
      this.range = [data.data.room.begin_at, data.data.room.end_at]
    },
    async getOralList () {
      const { data } = await api.get(`liveabc/oral_contents?page=${this.pageIndex}&pageSize=20&keyword=${this.search}`)
      this.oralList = data.data
      this.pageCount = data.last_page
    },
    async getSelectedOralList () {
      const { data } = await api.get(`liveabc/rooms/${this.roomId}/oral_contents`)
      this.selectedOralList = data.data
    },
    async getSelectedGroupList () {
      const { data } = await api.get(`liveabc/rooms/${this.roomId}/groups`)
      this.selectedGroupList = data.data
    },
    async addOral (id) {
      const fileData = new window.FormData()
      fileData.append('course_id', id)
      const { data } = await api.post(`liveabc/rooms/${this.roomId}/oral_contents`, fileData)
      this.getSelectedOralList()
    },
    async deleteOral (id) {
      const { data } = await api.delete(`liveabc/rooms/${this.roomId}/oral_contents/${id}`)
      this.getSelectedOralList()
    },
    async addGroup (id) {
      const fileData = new window.FormData()
      fileData.append('group_id', id)
      const { data } = await api.post(`liveabc/rooms/${this.roomId}/students`, fileData)
      this.getSelectedGroupList()
    },
    async deleteGroup (id) {
      const { data } = await api.delete(`liveabc/rooms/${this.roomId}/groups/${id}`)
      this.getSelectedGroupList()
    },
    async editRoomData () {
      const formData = {
        name: this.roomData.name,
        begin_at: this.range[0],
        end_at: this.range[1],
        is_repeatable: this.roomData.is_repeatable,
        sound_playable: this.roomData.sound_playable,
        is_show_score: this.roomData.is_show_score,
        note: this.roomData.note
      }

      const { data } = await api.patch(`liveabc/rooms/${this.roomId}`, formData)
      this.$router.push({ name: 'Room', params: { groupId: this.groupId } })
    },
    async examPreview () {
      const { data } = await api.get(`liveabc/rooms/${this.roomId}/preview`)
      this.examData = data.data
      if (this.coursesId === 0) {
        this.coursesId =  data.data[0].friendly_id
      }
    },
    getExam (idx) {
      this.examIndex = idx
    },
    async sentencesToggle (item) {
      const { data } = await api.post(`liveabc/rooms/${this.roomId}/courses/${this.coursesId}/sentences/${item.sent_no}/toggle`)
      this.examPreview()
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getOralList()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/color.scss";
  .room {
    text-align: left;
  }
  .list-group-item {
    width: 100%;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  .active {
    background-color: rgb(255, 152, 152) !important;
    border: rgb(255, 152, 152) !important;
  }
  .menu {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 10px 30px 10px 0;
    }
  }

  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .oralList {
    text-align: left;
    font-size: 1.25rem;
    label {
      padding: 0;
      margin-right: 3px;
      cursor: pointer;
    }
    input[type=checkbox] {
      display: none;
    }
    input[type=checkbox]+span {
      display: inline-block;
      background-color: #fff;
      padding: 3px 6px;
      border: 1px solid rgb(255, 105, 105);
      color: rgb(255, 105, 105);
      user-select: none; /* 防止文字被滑鼠選取反白 */
    }

    input[type=checkbox]:checked+span {
      color: #fff;
      background-color: rgb(255, 105, 105);
    }
    .oralLabel {
      font-size: 1.5rem;
    }
  }
</style>
